<!-- src/components/layouts/EnfermeroLayout.vue -->
<template>
  <div class="wrapper">
    <!-- Navbar -->
    <nav class="bg-white border-b border-gray-200 dark:bg-gray-800 dark:border-gray-700">
      <div class="px-3 py-3 lg:px-5 lg:pl-3">
        <div class="flex items-center justify-between">
          <div class="flex items-center justify-start">
            <span class="self-center text-xl font-semibold sm:text-2xl whitespace-nowrap dark:text-white ml-2">Sistema
              Clínico</span>
          </div>
          <!-- Botón del menú -->
          <div class="flex items-center">
            <button @click="toggleSidebar" type="button"
              class="inline-flex items-center p-2 text-sm text-gray-500 rounded-lg hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-200 dark:text-gray-400 dark:hover:bg-gray-700 dark:focus:ring-gray-600">
              <svg class="w-6 h-6" aria-hidden="true" fill="currentColor" viewBox="0 0 20 20"
                xmlns="http://www.w3.org/2000/svg">
                <path clip-rule="evenodd" fill-rule="evenodd"
                  d="M2 4.75A.75.75 0 012.75 4h14.5a.75.75 0 010 1.5H2.75A.75.75 0 012 4.75zm0 10.5a.75.75 0 01.75-.75h7.5a.75.75 0 010 1.5h-7.5a.75.75 0 01-.75-.75zM2 10a.75.75 0 01.75-.75h14.5a.75.75 0 010 1.5H2.75A.75.75 0 012 10z">
                </path>
              </svg>
            </button>
          </div>
        </div>
      </div>
    </nav>

    <!-- Sidebar Menu -->
    <div id="drawer-navigation" :class="{ 'translate-x-0': sidebarVisible, '-translate-x-full': !sidebarVisible }"
      class="fixed top-0 left-0 z-40 w-64 h-screen p-4 overflow-y-auto transition-transform bg-white dark:bg-gray-800"
      tabindex="-1" aria-labelledby="drawer-navigation-label">
      <h5 id="drawer-navigation-label" class="text-base font-semibold text-gray-500 uppercase dark:text-gray-400">Menu
      </h5>
      <button type="button" @click="toggleSidebar"
        class="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm p-1.5 absolute top-2.5 right-2.5 inline-flex items-center dark:hover:bg-gray-600 dark:hover:text-white">
        <svg aria-hidden="true" class="w-5 h-5" fill="currentColor" viewBox="0 0 20 20"
          xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd"
            d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
            clip-rule="evenodd"></path>
        </svg>
      </button>
      <div class="py-4 overflow-y-auto">
        <ul class="space-y-2 font-medium">
          <li>
            <router-link to="/enfermero/calendario" @click="hideSidebar"
              class="flex items-center p-2 text-gray-900 rounded-lg dark:text-white hover:bg-gray-100 dark:hover:bg-gray-700 group">
              <i class="fas fa-calendar-alt w-5 h-5 text-gray-500"></i>
              <span class="ms-3">Calendario</span>
            </router-link>
          </li>
          <li>
  <router-link to="/enfermero/mi-horario" @click="hideSidebar"
    class="flex items-center p-2 text-gray-900 rounded-lg dark:text-white hover:bg-gray-100 dark:hover:bg-gray-700 group">
    <i class="fas fa-clock w-5 h-5 text-gray-500"></i>
    <span class="ms-3">Mi Horario</span>
  </router-link>
</li>
           <li>
            <router-link to="/enfermero/crear-paciente" @click="hideSidebar"
              class="flex items-center p-2 text-gray-900 rounded-lg dark:text-white hover:bg-gray-100 dark:hover:bg-gray-700 group">
              <i class="fas fa-users w-5 h-5 text-gray-500"></i>
              <span class="ms-3">Clientes Activos</span>
            </router-link>
          </li>
          <li>
            <a @click="logout" href="#"
              class="flex items-center p-2 text-gray-900 rounded-lg dark:text-white hover:bg-gray-100 dark:hover:bg-gray-700 group">
              <i class="fas fa-sign-out-alt w-5 h-5 text-gray-500"></i>
              <span class="ms-3">Cerrar Sesión</span>
            </a>
          </li>
        </ul>
      </div>
    </div>

    <!-- Content Wrapper -->
    <div class="p-4">
      <div class="p-4 border-2 border-gray-200 rounded-lg dark:border-gray-700">
        <router-view />
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: 'EnfermeroLayout',
  data() {
    return {
      sidebarVisible: false,
    };
  },
  methods: {
    toggleSidebar() {
      this.sidebarVisible = !this.sidebarVisible;
    },
    hideSidebar() {
      this.sidebarVisible = false;
    },
    logout() {
      localStorage.removeItem('authToken');
      this.$router.push('/login');
    }
  }
};
</script>

<style scoped>
.wrapper {
  background-color: #f4f6f9;
}

.navbar {
  background-color: #007bff;
}

.sidebar {
  background-color: #343a40;
}

.sidebar .nav-link {
  color: #c2c7d0;
}

.sidebar .nav-link.active {
  background-color: #007bff;
  color: #ffffff;
}
</style>
